import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router,Route} from 'react-router-dom';
import './index.css';
import './utils.js';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { resolvePartnerDomain } from './partnerDomain';

const renderApp = () => {
  ReactDOM.render(
      <Router>
          <Route path="/" component={App} />
      </Router>,
      document.getElementById('root')
    );
};

// Resolve partner domain mapping BEFORE rendering.
//
// Header, Footer, Index, Impressum and TopSearch all read getPartnerData() /
// getPartnerIdFromDomain() synchronously while rendering. Those getters return
// values from a module-level cache that is only populated once this fetch
// resolves, and nothing re-renders afterwards. Firing this off without waiting
// meant the very first paint on a partner domain (alberto-pizza.de) always saw
// null and fell back to the generic Liefershops branding and the generic PLZ
// search flow. Awaiting it first is what makes partner domains actually work.
//
// A failed or slow lookup must never leave the visitor staring at a blank page,
// so cap the wait and render regardless of the outcome.
const partnerLookupTimeout = new Promise((resolve) => setTimeout(resolve, 2500));

Promise.race([resolvePartnerDomain().catch(() => null), partnerLookupTimeout])
  .then(renderApp)
  .catch(renderApp);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
